import React, { useEffect, useRef } from "react";

const VideoBackground = ({ video }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    const videoElement = videoRef.current;
    if (videoElement) {
      videoElement.muted = true; // Ensure it's muted for autoplay
      videoElement.play().catch((err) => {
        console.error("Autoplay failed:", err);
      });
    }
  }, []);

  return (
    <video
      ref={videoRef}
      autoPlay
      playsInline
      muted
      loop
      id="myVideo"
      className="block absolute left-0 top-0 w-full h-full object-cover"
    >
      <source src={video} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  );
};

export default VideoBackground;
